import { nl2br } from '../../utils';

import styles from './DetailDescription.module.css';

interface IProps {
  title: string;
  client?: string;
  description: string;
}

export default function DetailDescription({ title, client, description }: IProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.description}>
        <h2 className={styles.header}>{title}</h2>
        {client && <p className={styles.clientLine}>Client: {client}</p>}
        <p>{nl2br(description)}</p>
      </div>
    </div>
  );
}
